/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Input, Modal, Row, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import BreakLine from "../../../component/Desktop/breakLine";
import GroupItem from "../../../component/Desktop/groupItem";
import Loading from "../../../component/Desktop/loading/loading";
import RowInput from "../../../component/Desktop/rowInput";
import TitlePage from "../../../component/Desktop/titlePage";
import {
  COMMON_CONSTANT,
  KEY,
  lang,
  STYLE,
} from "../../../constants/common.const";
import {
  handleCatchError,
  renderOption,
  showMessage,
} from "../../../constants/utils";

import {
  CloseCircleOutlined,
  SaveOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

import classDdl from "../../../models/control/dropdownlist";
import classText from "../../../models/control/text";
import { ApiDisaster } from "../../../api/backend/disaster";
import kbn from "../../../api/backend/kbn";
import { DebounceSelect } from "../../../utils/helper";
import { isEmpty } from "lodash";
import API_EM from "../../../api/backend/employee";
import { setOptions } from "highcharts";

//Declare global variables
const { TextArea } = Input;
function AddDisaster() {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  const { allowRoute, headOfficeRole, roles } = useSelector(
    (state) => state.auth
  );

  // Loading
  const openLoadingSpinner = () => {
    setShowLoading(true);
  };

  const closeLoadingSpinner = () => {
    setShowLoading(false);
  };

  const [txtNameDisaster, settxtNameDisaster] = useState(new classText()); //Required
  const [ddlCategory, setddlCategory] = useState(new classDdl()); //Required
  const [factory, setfactory] = useState(new classDdl()); //Required
  const [txtNote, settxtNote] = useState(new classText()); //Required

  const [txtUser, setTxtUser] = useState(new classText());

  const txtNameDisasterEl = useRef(null);
  const ddlCategoryEl = useRef(null);
  const factoryEl = useRef(null);
  const txtNoteEl = useRef(null);
  const [selectUser, setSelectUser] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  // SAVE
  const onSaveData = async () => {
    try {
      openLoadingSpinner();
      const dataPost = {
        siteOfficeMasterCode: factory.value,
        name: txtNameDisaster.value,
        categoryId: ddlCategory.value,
        note: txtNote.value,
        conversations: [],
        notifyTo: selectUser.map((i) => i.value).join(","),
      };
      !id
        ? await ApiDisaster.addDisaster(dataPost)
        : await ApiDisaster.updateDisaster(dataPost, id);
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, () => {
        history.goBack();
      });
    } catch (error) {
      handleCatchError(error);
    } finally {
      closeLoadingSpinner();
    }
  };
  // Popup common
  const showConfirmMessage = (
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    let ok, cancel;
    const callBackDefault = () => {
      Modal.destroyAll();
    };

    // Callback OK exist
    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }
    // Callback Cancel exist
    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      centered: true,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };

  //Save function: 1
  function confirmSaveData() {
    if (!validateSave()) {
      return;
    }
    showConfirmMessage(COMMON_CONSTANT.BOM_C008, onSaveData);
  }

  // Validate
  function validateSave() {
    let flagErr = false,
      elmFocus;

    let checkFactory, checkCategory, checkNameDisaster;

    if (!factory.value) {
      flagErr = true;
      // Border red
      checkFactory = { ...factory, error: true };
      elmFocus = factoryEl;
    } else {
      checkFactory = { ...factory, error: false };
    }
    if (!ddlCategory.value) {
      flagErr = true;
      // Border red
      checkCategory = { ...ddlCategory, error: true };
      elmFocus = ddlCategoryEl;
    } else {
      checkCategory = { ...ddlCategory, error: false };
    }
    if (txtNameDisaster.value.trim().length === 0) {
      flagErr = true;
      // Border red
      checkNameDisaster = { ...txtNameDisaster, error: true };
      elmFocus = txtNameDisasterEl;
    } else {
      checkNameDisaster = { ...txtNameDisaster, error: false };
    }

    // Focus item error
    elmFocus && elmFocus.current.focus();

    // Update state
    settxtNameDisaster(checkNameDisaster);
    setddlCategory(checkCategory);

    setfactory(checkFactory);

    return !flagErr;
  }

  // detail
  const getInitData = async () => {
    try {
      if (id) {
        setShowLoading(true);
      }
      const [detailRes, categoryRes, officeRes] = await Promise.all([
        id ? ApiDisaster.getDetailDisaster(id) : null,
        ApiDisaster.searchCategory(),
        kbn.getSiteOffice(),
      ]);

      // Edit Mode
      if (id) {
        settxtNameDisaster({ ...txtNameDisaster, value: detailRes.data.name });
        setddlCategory({
          ...ddlCategory,
          options: categoryRes.data,
          value: detailRes.data.categoryId,
        });
        setfactory({
          ...factory,
          options: officeRes.data.data,
          value: detailRes.data.siteOfficeMasterCode,
        });
        settxtNote({ ...txtNote, value: detailRes.data.note });

        initSelectUser(detailRes.data.notifyTo);
      } else {
        setddlCategory({ ...ddlCategory, options: categoryRes.data });
        setfactory({ ...factory, options: officeRes.data.data });
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setShowLoading(false);
    }
  };
  // Init data
  useEffect(() => {
    getInitData();
  }, [id]);
  // Fetch user Select
  const fetchUserSelect = async (value) => {
    try {
      const res = await API_EM.searchUser({
        Keyword: value,
        type: "unten",
      });

      if (res && !isEmpty(res.data)) {
        return res.data.map((item) => ({
          ...item,
          label: item.displayName,
          value: item.userName,
        }));
      }
      return [];
    } catch (e) {
    }
  };

  const initSelectUser = async (userStrings = "") => {
    const listOps = userStrings
      ? userStrings.split(",").map((i) => ({
          value: i,
          label: i,
        }))
      : [];
    setUserOptions(listOps);
    setSelectUser(listOps);
  };
  return (
    <div className="des-content">
      <Loading show={showLoading}></Loading>
      <TitlePage name={id ? lang.DISASTER_EDIT : lang.DISASTER_ADD} />

      <GroupItem center>
        <div className="title-page d-block center mt0 mb0">
          <h1 className="bold white-space">
            {id ? lang.DISASTER_EDIT : lang.DISASTER_ADD}
          </h1>
        </div>
        <div className="mt15"></div>
        <BreakLine />
        <RowInput name={lang.DISASTER_NAME} required box>
          <Input
            ref={txtNameDisasterEl}
            className={txtNameDisaster.error ? STYLE.BORDER_RED : ""}
            value={txtNameDisaster.value}
            onChange={(v) => {
              settxtNameDisaster({
                ...txtNameDisaster,
                value: v.target.value,
              });
            }}
          />
        </RowInput>
        <BreakLine />
        <RowInput name={lang.DISASTER_CATEGORY} required box>
          <Select
            ref={ddlCategoryEl}
            value={ddlCategory.value}
            className={ddlCategory.error ? `${STYLE.BORDER_RED} w100` : "w100"}
            onChange={(v) => {
              setddlCategory({ ...ddlCategory, value: v });
            }}
          >
            {renderOption(ddlCategory.options)}
          </Select>
        </RowInput>
        <BreakLine />
        <RowInput name={lang.FACTORY_MAME} required box>
          <Select
            disabled={id}
            ref={factoryEl}
            value={factory.value}
            className={factory.error ? `${STYLE.BORDER_RED} w100` : "w100"}
            onChange={(v) => {
              setfactory({ ...factory, value: v });
            }}
          >
            {renderOption(factory.options, true, true)}
          </Select>
        </RowInput>
        <BreakLine />

        <RowInput name={lang.USER_SELECT_DISASTER} box>
          <DebounceSelect
            disabled={id}
            mode={"multiple"}
            style={{ width: "100%" }}
            maxTagCount="responsive"
            value={selectUser}
            placeholder={lang.USER_SELECT_DISASTER}
            defaultOptions={userOptions}
            fetchOptions={fetchUserSelect}
            onChange={(newValue) => setSelectUser(newValue)}
            allowClear
            forceFetch={false}
          />
        </RowInput>
        <BreakLine />
        <RowInput name={lang.NOTE} box>
          <TextArea
            ref={txtNoteEl}
            className={txtNote.error ? STYLE.BORDER_RED : ""}
            value={txtNote.value}
            onChange={(v) => {
              settxtNote({
                ...txtNote,
                value: v.target.value,
              });
            }}
            rows={12}
          />
        </RowInput>
        <BreakLine />
        {/* Button footer */}
        <Row justify="end" className="mt10 mb10">
          <Button
            className="buttonPC button--info wAuto ml15"
            onClick={() => {
              confirmSaveData();
            }}
          >
            <SaveOutlined />
            {COMMON_CONSTANT.SAVE}
          </Button>
          <Button
            onClick={() => history.goBack()}
            className="buttonPC button--outline --todo-- wAuto ml15"
          >
            <CloseCircleOutlined />
            {lang.CANCEL}
          </Button>
        </Row>
      </GroupItem>
    </div>
  );
}

export default AddDisaster;
